import React from 'react'
import FormCheckbox from '../../../../library/form/components/FormCheckbox';
import FormROValue from "../../../../library/form/components/FormROValue1"

const RolePrivilegeAdvScopeEditorRow = (props) => {
    const { formObject, rowValueKey } = props;
    
    if( rowValueKey === "docType")
        return(null);

    return (
        <li>
            <div className='uiFlexBox'>
                <div className='uiWidth150'>
                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: rowValueKey }} />
                </div>
                <FormCheckbox formObject={formObject} rowKey="" onValue="yes" offValue="no" action={{ InputType: 'onOff', paramName: rowValueKey }} />
            </div>
        </li>
    )
}

export default RolePrivilegeAdvScopeEditorRow